import moment from 'moment';

export function ISOtoDateString(ISODate){
    return moment.utc(ISODate).format('DD-MM-YYYY')
}

export function formatCurrency(amount) {
    return `£ ${amount ? amount.toFixed(2) : 0}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}